import React, { CSSProperties, ReactNode } from 'react';

import { CommonLinkProps } from './common.style';
type AnchorProperties = React.HTMLAttributes<HTMLAnchorElement>;
type PropsUnstyledLink = AnchorProperties &
  CommonLinkProps & {
    children: ReactNode;
    href: string;
    target?: '_blank' | '_self';
    className?: string;
    style?: CSSProperties;
    allowReferrer?: boolean;
  };

export default function UnstyledLink({
  href,
  children,
  style,
  className,
  target,
  allowReferrer,
  ...rest
}: PropsUnstyledLink) {
  if (!href) {
    console.log('UnstyledLink: href is not defined');
    console.trace();
    return <div>-</div>;
  }
  return (
    <a
      {...rest}
      href={href}
      target={
        target
          ? target
          : // External URL
          href.startsWith('http') || href.startsWith('//')
          ? '_blank'
          : href.startsWith('#')
          ? undefined
          : '_blank'
      }
      rel={allowReferrer ? 'noopener' : 'noreferrer noopener'}
      className={className}
      style={style}
      onClick={
        rest.onClick ||
        (event => {
          if (rest.disabled) {
            event?.preventDefault();
            return false;
          }
        })
      }
    >
      {children}
    </a>
  );
}
